import HttpResponse from "../../../../../utils/http/http.response";

export enum ContractsTaxiForwardingContractListResponseItemModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsTaxiForwardingContractListResponseItemTaxiCorporation = {
  companyName: string;
};

export type ContractsTaxiForwardingContractListResponseItem = {
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsTaxiForwardingContractListResponseItemModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  id: string;
  producerTaxi: ContractsTaxiForwardingContractListResponseItemTaxiCorporation;
  consumerTaxi: ContractsTaxiForwardingContractListResponseItemTaxiCorporation;
  displayName: string | null;
  isPartner: boolean;
  priority: number;
};

type ContractsTaxiForwardingContractListResponse = HttpResponse<{
  data: ContractsTaxiForwardingContractListResponseItem[];
  totalCount: number;
}>;

export default ContractsTaxiForwardingContractListResponse;
